import React from 'react';

import * as BoxC from './_ccbBoxC';
import * as IconC from './_ccbIconC';
import * as TextC from './_ccbTextC';
import { a } from './_cmABT';
import * as _cr from './_cr';
import * as _hm from './_hm';
import * as _ht from './_ht';

export type tBtnCz = {
  abtz: _ht.dz,
  lblCz?: TextC.tTextCz,
  frmCz?: BoxC.tBoxCz,
  bfrIconCz?: IconC.tIconCz,
  atrIconCz?: IconC.tIconCz,
  bfrCld?: _ht.o,
  atrCld?: _ht.o,
};

const $grtAbtz = (pz?: {
  type?: _ht.s,
  br?: _ht.n,
  dh?: _ht.n,
  dw?: _ht.n,
  icc?: _ht.s,
  icn?: _ht.s,
  ics?: _ht.n,
  tc?: _ht.s,
  text?: _ht.s,
  ts?: _ht.s,
  sc?: _ht.s,
}) => {
  const _br = pz?.br ?? 1;
  const _dh = pz?.dh ?? 'f';
  const _dw = pz?.dw ?? 'f';
  const _tc = pz?.tc ?? 'lt1';
  const _text = pz?.text ?? '';
  const _ts = pz?.ts ?? 'm';
  const _sc = pz?.sc ?? 'lt7';
  const _icc = pz?.icc ?? 'lt1';
  const _ics = pz?.ics ?? 2;
  const _icn = pz?.icn ?? '';
  switch (pz?.type) {
    case 'icon':
      return {
        lblCz: {
          text: _text,
          textStlz: a(`tb tc/${_tc} ts/${_ts}`),
          textPtyz: {},
          boxStlz: {},
          boxPslz: {},
        },
        frmCz: {
//          boxStlz: a(`br/${_br} dw/${_dw} dh/${_dh} fd/rcc sc/${_sc}`),
          boxStlz: a(`fd/ccc p/1`),
          boxPslz: {},
          pslStlz: a(`dw/f fd/ccc`),
        },
        bfrIconCz: {
          iconPtyz: a(`icc/${_icc} icn/${_icn} ics/${_ics}`)
        },
        atrIconCz: {
          iconPtyz: {},
          boxStlz: {},
        },
      }
    case 'ctd': // contained
      return {
        lblCz: {
          text: _text,
          textStlz: a(`tb tc/${_tc} ts/${_ts}`),
          textPtyz: {},
          boxStlz: {},
          boxPslz: {},
        },
        frmCz: {
          boxStlz: a(`br/${_br} dw/${_dw} dh/${_dh} fd/rcc sc/${_sc}`),
          boxPslz: {},
          pslStlz: a(`dw/f fd/ccc`),
        },
        bfrIconCz: {
          iconPtyz: 
            _hm.f(_icn) ?
              a(`icc/${_icc} icn/${_icn} ics/${_ics}`)
            : {},
          boxStlz:
            _hm.f(_icn) ?
              a(`mr/1`)
            : {},
        },
        atrIconCz: {
          iconPtyz: {},
          boxStlz: {},
        },
      }
    default:
      return {
        lblCz: {
          text: '',
          textStlz: {},
          textPtyz: {},
          boxStlz: {},
          boxPslz: {},
        },
        frmCz: {
          boxStlz: {},
          boxPslz: {},
          pslStlz: a(`dw/f fd/ccc`),
        },
        bfrIconCz: {
          iconPtyz: {},
          boxStlz: {},
        },
        atrIconCz: {
          iconPtyz: {},
          boxStlz: {},
        },
      }
  }
};

export const N = React.memo((pz: tBtnCz) => {

  const _abtz = $grtAbtz(pz.abtz)

//_hm.l(`BtnC 127: ${_hm.s(_abtz)}`);
  let _bPrs = false;

  return (
    _cr.c(BoxC.N, {
      boxStlz: {
        ..._abtz.frmCz?.boxStlz,
        ...pz.frmCz?.boxStlz
      },
      pslStlz: {
        ... _abtz.frmCz?.pslStlz,
        ... pz.frmCz?.pslStlz,
      },
      pslPtyz: {
        ... pz.frmCz?.pslPtyz,
        onPrs: async () => {
          if (_bPrs == false) {
            //_hm.l(`BtnsC 144: here`);
            _bPrs = true;
            if (pz.frmCz?.pslPtyz?.onPrs) await pz.frmCz?.pslPtyz.onPrs();
            //await _hm.waitAsync(3000);
            _bPrs = false;
          }
        }
      },
      boxClds: [

        pz.bfrCld ?
          pz.bfrCld
        : null,

        _hm.f(pz.bfrIconCz?.iconPtyz) || _hm.f(_abtz.bfrIconCz?.iconPtyz) ?
        _cr.c(IconC.N, {
          key: -20,
          boxStlz: {
            ... _abtz.bfrIconCz?.boxStlz,
            ... pz.bfrIconCz?.boxStlz,
          },
          iconPtyz: {
            ... _abtz.bfrIconCz?.iconPtyz,
            ... pz.bfrIconCz?.iconPtyz,
          },
        })
        : null,

        (_hm.f(pz.lblCz?.text) || _hm.f(_abtz.lblCz?.text)) ?
        _cr.c(TextC.N, {
          key: -30,
          boxStlz: {
            ... _abtz.lblCz?.boxStlz,
            ... pz.lblCz?.boxStlz,
          },
          text: pz.lblCz?.text ?? _abtz.lblCz?.text,
          textStlz: {
            ... _abtz.lblCz?.textStlz,
            ... pz.lblCz?.textStlz,
          },
        })
        : null,

        pz.atrIconCz ?
        _cr.c(IconC.N, {
          key: -40,
          boxStlz: {
            ... _abtz.atrIconCz?.boxStlz,
            ... pz.atrIconCz?.boxStlz,
          },
          iconPtyz: {
            ... _abtz.atrIconCz?.iconPtyz,
            ... pz.atrIconCz?.iconPtyz,
          },
        })
        : null,

        pz.atrCld ?
          pz.atrCld
        : null,

      ]
    })
  );
});
